import React from 'react';
import { DrawerBody, Typography } from '@one-thd/sui-atomic-components';

const LOADING_GIF_URL = 'https://assets.thdstatic.com/images/v1/brick-loading-icon.gif';

export const AILoadingAnimation = () => {
  return (
    <DrawerBody>
      <div
        className="sui-flex sui-flex-col sui-items-center sui-justify-center sui-text-center sui-gap-4 sui-py-6"
        data-testid="ai-loading-animation"
      >
        <Typography variant="h3" weight="display">
          Building your list from the ground up.
        </Typography>
        <img
          src={LOADING_GIF_URL}
          alt="AI building your list"
          width="300"
          height="300"
        />
        <Typography variant="h3" weight="display">
          We&apos;re gathering, stacking, and rebuilding until it&apos;s just right.
        </Typography>
      </div>
    </DrawerBody>
  );
};

AILoadingAnimation.displayName = 'AILoadingAnimation';
